import { CommonModule } from '@angular/common'
import { OfferButtonCardComponent } from '../offers/offer-button/offer-button-card.component'
import { PlansPromoCardComponent } from './plans-promo-card.component'
import { PlansPromoSectionComponent } from './plans-section/plans-promo-section.component'
import { NgModule } from '@angular/core'
import { FunnelSharedModule } from '../../shared/funnel-shared.module'

@NgModule({
  declarations: [OfferButtonCardComponent, PlansPromoCardComponent, PlansPromoSectionComponent],
  imports: [CommonModule, FunnelSharedModule],
  exports: [PlansPromoCardComponent, PlansPromoSectionComponent, OfferButtonCardComponent]
})
export class PlansPromoModule {}
